import React from "react";
import graphql from "graphql";
import Layout from "./index";
import { addLocaleData } from "react-intl";

import messages from "../data/messages/es";
import es from "react-intl/locale-data/es";
import "intl/locale-data/jsonp/es";

addLocaleData(es);

export default props => <Layout {...props} i18nMessages={messages} />;

export const pageQuery = graphql`
  query LayoutEs {
    site {
      siteMetadata {
        title
        languages {
          defaultLangKey
          langs
        }
      }
    }

    consulting01: file(name: { eq: "01consulting" }) {
      childImageSharp {
        sizes {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }

    sindicatos02: file(name: { eq: "02sindicatos" }) {
      childImageSharp {
        sizes {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }

    outsourcing03: file(name: { eq: "03outsourcing" }) {
      childImageSharp {
        sizes {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }

    bg: file(name: { eq: "bg" }) {
      childImageSharp {
        sizes {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }

    about: file(name: { eq: "about" }) {
      childImageSharp {
        sizes {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }

    outsourcing: file(name: { eq: "outsourcing" }) {
      childImageSharp {
        sizes {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }

    siglas01: file(name: { eq: "siglas01" }) {
      childImageSharp {
        sizes(quality: 100, maxWidth: 1600) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    siglas02: file(name: { eq: "siglas02" }) {
      childImageSharp {
        sizes(quality: 100, maxWidth: 1600) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    siglas03: file(name: { eq: "siglas03" }) {
      childImageSharp {
        sizes(quality: 100, maxWidth: 1600) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    siglas04: file(name: { eq: "siglas04" }) {
      childImageSharp {
        sizes(quality: 100, maxWidth: 1600) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    boleta01: file(name: { eq: "boleta01" }) {
      childImageSharp {
        sizes(quality: 100, maxWidth: 1600) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    boleta02: file(name: { eq: "boleta02" }) {
      childImageSharp {
        sizes(quality: 100, maxWidth: 1600) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    boleta03: file(name: { eq: "boleta03" }) {
      childImageSharp {
        sizes(quality: 100, maxWidth: 1600) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    boleta04: file(name: { eq: "boleta04" }) {
      childImageSharp {
        sizes(quality: 100, maxWidth: 1600) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    aportes01: file(name: { eq: "aportes01" }) {
      childImageSharp {
        sizes(quality: 100, maxWidth: 1600) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    aportes02: file(name: { eq: "aportes02" }) {
      childImageSharp {
        sizes(quality: 100, maxWidth: 1600) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    aportes03: file(name: { eq: "aportes03" }) {
      childImageSharp {
        sizes(quality: 100, maxWidth: 1600) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    aportes04: file(name: { eq: "aportes04" }) {
      childImageSharp {
        sizes(quality: 100, maxWidth: 1600) {
          ...GatsbyImageSharpSizes
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/es.js